const ptrValidator = (value) => {
  if (!value) return "validate.ptr_empty";
  const regex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;
  return regex.test(value) ? true : "validate.ptr_failed";
};

export { ptrValidator };
